// src/pages/personal/platforms/OrdersPage.tsx
import React from 'react';
import { AdaptiveLayout } from '@/components/ui/Layout';
import OrdersSection from './OrdersSection/OrdersSection';

const OrdersPage: React.FC = () => {
  return (
    <AdaptiveLayout>
      <OrdersSection />
    </AdaptiveLayout>
  );
};

export default OrdersPage;